var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view',{staticClass:"header",attrs:{"name":"header"},scopedSlots:_vm._u([{key:"share-menu",fn:function(){return [_c('HeaderMenuShare')]},proxy:true}])}),_c('router-view',{staticClass:"page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }